import React from 'react';
import { Calendar as CalendarIcon, Zap, Check, XCircle } from 'lucide-react';

interface StatusSelectorProps {
    currentStatus: string;
    onStatusChange: (status: string) => void;
}

/**
 * StatusSelector: Visual selector for event status (PLANNED, ACTIVE, etc.).
 * SHADOW VERSION (.tsx)
 */
export const StatusSelector: React.FC<StatusSelectorProps> = ({ currentStatus, onStatusChange }) => {
    const statuses = [
        { id: 'PLANNED', label: 'PLANNED', color: '#f29b11', icon: CalendarIcon },
        { id: 'ACTIVE', label: 'ACTIVE', color: '#3b82f6', icon: Zap },
        { id: 'COMPLETED', label: 'COMPLETED', color: '#2ecc71', icon: Check },
        { id: 'SKIPPED', label: 'SKIPPED', color: '#ef4444', icon: XCircle }
    ];

    return (
        <div style={{ 
            display: 'flex', 
            backgroundColor: '#050505', 
            padding: '2px', 
            borderRadius: '8px', 
            border: '1px solid #1a1a1a', 
            gap: '2px',
            marginTop: '12px',
            width: '100%',
            boxSizing: 'border-box'
        }}>
            {statuses.map(s => {
                const isSelected = currentStatus === s.id;
                const Icon = s.icon;
                return (
                    <button 
                        key={s.id} 
                        onClick={() => onStatusChange(s.id)} 
                        style={{ 
                            all: 'unset', 
                            flex: 1, 
                            padding: '10px 0', 
                            borderRadius: '6px', 
                            backgroundColor: isSelected ? `${s.color}1a` : 'transparent', 
                            border: `1px solid ${isSelected ? s.color : 'transparent'}`, 
                            display: 'flex', 
                            alignItems: 'center', 
                            justifyContent: 'center', 
                            gap: '6px', 
                            cursor: 'pointer', 
                            transition: 'all 0.2s ease', 
                            // Unselected opacity higher for readability
                            opacity: isSelected ? 1 : 0.6 
                        }}
                        aria-label={s.label}
                    >
                        {/* Use actual color but lower opacity for unselected icon/text */}
                        <Icon size={12} color={s.color} style={{ opacity: isSelected ? 1 : 0.5 }} />
                        <span style={{ 
                            fontSize: '9px', 
                            fontWeight: '900', 
                            color: isSelected ? '#fff' : s.color,
                            opacity: isSelected ? 1 : 0.7
                        }}>
                            {s.id}
                        </span>
                    </button>
                );
            })}
        </div>
    );
};
